import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Injectable } from '@angular/core';

import { ZefApi } from '@shared/services/zef-api.service';
import { AIApiPath, AiApiRoute, AiMessage, AiPromptConfig, AiPromptOptions } from '@shared/models/ai.model';
import { AIModelDependentMessage } from '@shared/utilities/string.utilities';

@Injectable({
  providedIn: 'root',
})
export class AiApiService {
  readonly defaultTemperature = 0.5;

  constructor(private api: ZefApi) {}

  prompt<T = string>(messages: AiMessage[], options?: AiPromptOptions): Observable<T> {
    options = {
      temperature: this.defaultTemperature,
      ...options,
    };

    return this.api.post(`${AIApiPath}/${AiApiRoute.Prompt}`, { messages, ...options }).pipe(
      map((response) => response?.[0]?.message),
      map((message) => {
        if (options.functionName) {
          try {
            return JSON.parse(message?.function_call?.arguments);
          } catch (e) {
            console.log(e);
          }
        } else {
          return message?.content;
        }
      }),
    );
  }

  promptConfig<T = string>(config: AiPromptConfig, messages: AiMessage[], options?: AiPromptOptions): Observable<T> {
    options = {
      temperature: this.defaultTemperature,
      ...options,
    };
    const isImageModel: boolean = !!options?.modelKey?.startsWith('dall-e');

    return this.api.post(`${AIApiPath}/${AiApiRoute.Esko}/${config}`, { messages, ...options }).pipe(
      map((response: any) =>
        !isImageModel
          ? options.functionName
            ? response?.[0]?.message?.function_call?.arguments
            : AIModelDependentMessage(response)
          : response?.images?.content,
      ),
      map((message) => {
        if (options.functionName) {
          try {
            return JSON.parse(message);
          } catch (e) {
            console.log(e);
          }
        } else {
          return message;
        }
      }),
    );

    //    const url: string = `https:${environment.apiServer}/ai/esko/summarizeBackgroundInfo`;
    //     const data: { [prop: string]: any } = {
    //       temperature: 0.7,
    //       model: 3,
    //       messages: [{ role: 'user', message: content }],
    //     };
  }
}

// const i = {
//   type: 'object',
//   properties: {
//     company_name: { type: 'string', description: 'The name of the company' },
//     company_description: { type: 'string', description: 'The description of the company' },
//     company_survey_suggestions: {
//       type: 'array',
//       description: 'Surveys suited to be issued by the company',
//       items: {
//         type: 'object',
//         description: 'Survey suited to be issued by the company',
//         properties: {
//           company_survey_type: {
//             type: 'string',
//             description: 'The type of the survey for the company',
//           },
//           company_survey_description: {
//             type: 'string',
//             description: 'A short description about the benefits of this survey type for the company',
//           },
//         },
//       },
//     },
//   },
// };
